<template>
  <div>
    <div class="card mb-4 pt-2">
      <div class="card-body p-4 p-md-5">
        <p class="description" v-html="$t('personal_information.gdpr_text')" />
      </div>
    </div>
    <personal-info-form v-if="registered" />
    <registration-form v-else />
  </div>
</template>

<script>
import RegistrationForm from "@/components/RegistrationForm";
import PersonalInfoForm from "../components/PersonalInfoForm";
import { token } from "@/store/modules/onboarding";

export default {
  name: "personalInfo",
  components: {
    RegistrationForm,
    PersonalInfoForm
  },
  created() {
    if (this.token) {
      this.$store.commit("onboarding/setRegistration", true);
      this.$emit("can-continue", { value: true });
    } else {
      this.$store.commit("onboarding/setRegistration", false);
      this.$emit("can-continue", { value: false });
    }
  },
  computed: {
    token() {
      return token();
    },
    registered() {
      return this.$store.state.onboarding.registered;
    }
  },
  watch: {
    token() {
      if (!this.token) {
        this.$store.commit("onboarding/setRegistration", false);
      }
    }
  }
};
</script>
